import { Button } from 'primereact/button'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Tag } from 'primereact/tag'
import Table from '../../components/layout/Table'
import Modal from '../../components/popup/Modal'
import vanBangBanSaoState, { getVanBangBanSaoState } from '../../constant/vanBangBanSaoState'
import vanBangBanSaoProcessor from '../../processor/vanBangBanSaoProcessor'
import { dateToDDMMYY } from '../../utils/date'

const LichSuVanBangBanSao = (props) => {
  const { visible, toggle, data } = props
  const [datas, setDatas] = useState([])
  const users = useSelector((state) => state.user.users)

  useEffect(async () => {
    if (data.id) {
      const rs = await vanBangBanSaoProcessor.getByVanBang(data.id)
      setDatas(rs)
    }
  }, [data])

  const footer = () => (
    <div className="flex justify-content-end w-full pt-2">
      <Button label="Huỷ" className="p-button-secondary mr-2" onClick={toggle} />
    </div>
  )

  const columnTable = [
    {
      value: 'soHieuBanChinh',
      name: 'Số hiệu cũ',
      render: (item) => item.vanBang && item.vanBang.soHieu,
    },
    { value: 'soHieu', name: 'Số hiệu mới' },
    { value: 'soVaoSo', name: 'Số vào sổ' },
    { value: 'soBan', name: 'Số bản' },
    { value: 'soBan', name: 'Số bản' },
    {
      value: 'ngayTao',
      name: 'Ngày tạo',
      render: (item) => {
        return dateToDDMMYY(new Date(item.ngayTao))
      },
    },
    {
      value: 'nguoiDuyetId',
      name: 'Người duyệt',
      render: (item) => {
        const user = users.find((u) => u.id === item.nguoiDuyetId)
        return user ? user.fullname : ''
      },
    },
    {
      value: 'trangThai',
      name: 'Trạng thái',
      render: (item) => (
        <Tag
          severity={item.trangThai === vanBangBanSaoState.choDuyet ? 'danger' : ''}
          value={getVanBangBanSaoState(item.trangThai)}
        />
      ),
    },
  ]

  return (
    <Modal visible={visible} toggle={toggle} footer={footer} width="80%">
      <Table data={datas} column={columnTable} />
    </Modal>
  )
}
export default LichSuVanBangBanSao
